import { render, staticRenderFns } from "./PrizeSelect.vue?vue&type=template&id=bd43b65a&scoped=true"
import script from "./PrizeSelect.vue?vue&type=script&lang=js"
export * from "./PrizeSelect.vue?vue&type=script&lang=js"
import style0 from "./PrizeSelect.vue?vue&type=style&index=0&id=bd43b65a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd43b65a",
  null
  
)

export default component.exports